import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
  routes:[
    {
      name:"网站首页",
      path:"/",
      redirect:"dashboard",
      component:()=>import("@/views"),
      meta:{activeName:"网站首页"},
      children:[
        {
          name:"网站首页",
          path:"dashboard",
          component:()=>import("@/views/dashboard"),
          meta:{activeName:"网站首页"},
        },
        {
          name:"HOACCU",
          path:"hoaccu",
          component:()=>import("@/views/hoaccu"),
          redirect:"hoaccu/companyProfile",
          meta:{activeName:"HOACCU"},
          children:[
            {
              name:"公司简介",
              path:"companyProfile",
              component:()=>import("@/views/hoaccu/baseInfo"),
              meta:{activeName:"HOACCU"},
            },
            {
              name:"企业文化",
              path:"enterpriseCulture",
              component:()=>import("@/views/hoaccu/baseInfo"),
              meta:{activeName:"HOACCU"},
            },
            {
              name:"人力资源",
              path:"manpowerResource",
              component:()=>import("@/views/hoaccu/baseInfo"),
              meta:{activeName:"HOACCU"},
            },
            {
              name:"发展历程",
              path:"developmentHistory",
              component:()=>import("@/views/hoaccu/baseInfo"),
              meta:{activeName:"HOACCU"},
            },
            {
              name:"荣誉证书",
              path:"certificateHonor",
              component:()=>import("@/views/hoaccu/otherInfo"),
              meta:{activeName:"HOACCU"},
              children:[
                {
                  name: "荣誉证书详情",
                  path: "detail/:id",
                  component: () => import("@/views/hoaccu/detail"),
                  meta: {activeName: "HOACCU",activeSubName:"荣誉证书"},
                }
              ]
            },
            {
              name:"合作伙伴",
              path:"partner",
              component:()=>import("@/views/hoaccu/otherInfo"),
              meta:{activeName:"HOACCU"},
              children:[
                {
                  name: "合作伙伴详情",
                  path: "detail/:id",
                  component: () => import("@/views/hoaccu/detail"),
                  meta: {activeName: "HOACCU",activeSubName:"合作伙伴"},
                }
              ]
            },
            {
              name:"案例展示",
              path:"showCase",
              component:()=>import("@/views/hoaccu/otherInfo"),
              meta:{activeName:"HOACCU"},
              children:[
                {
                  name: "案例展示详情",
                  path: "detail/:id",
                  component: () => import("@/views/hoaccu/detail"),
                  meta: {activeName: "HOACCU",activeSubName:"案例展示"},
                }
              ]
            },
            {
              name:"代理加盟",
              path:"agent",
              component:()=>import("@/views/hoaccu/baseInfo"),
              meta:{activeName:"HOACCU"},
            },
          ]
        },
        {
          name:"数控加工中心",
          path:"machiningCenter",
          component:()=>import("@/views/hoaccu"),
          meta:{activeName:"数控加工中心"},
          redirect:"machiningCenter/vertical",
          children:[
            {
              name:"立式加工中心",
              path:"vertical",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控加工中心"},
              children:[
                {
                  name: "立式加工中心详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控加工中心",activeSubName:"立式加工中心"},
                }
              ]
            },
            {
              name:"硬轨加工中心",
              path:"hardRail",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控加工中心"},
              children:[
                {
                  name: "硬轨加工中心详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控加工中心",activeSubName:"硬轨加工中心"},
                }
              ]
            },
            {
              name:"两线一硬加工中心",
              path:"railLine",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控加工中心"},
              children:[
                {
                  name: "两线一硬加工中心详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控加工中心",activeSubName:"两线一硬加工中心"},
                }
              ]
            },
            {
              name:"三线加工中心",
              path:"threeLine",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控加工中心"},
              children:[
                {
                  name: "三线加工中心详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控加工中心",activeSubName:"三线加工中心"},
                }
              ]
            },
            {
              name:"高速加工中心",
              path:"highSpeed",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控加工中心"},
              children:[
                {
                  name: "高速加工中心详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控加工中心",activeSubName:"高速加工中心"},
                }
              ]
            },
            {
              name:"高速钻攻中心机",
              path:"drailMilling",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控加工中心"},
              children:[
                {
                  name: "高速钻攻中心机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控加工中心",activeSubName:"高速钻攻中心机"},
                }
              ]
            },
            {
              name:"卧式加工中心",
              path:"hs",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控加工中心"},
              children:[
                {
                  name: "卧式加工中心详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控加工中心",activeSubName:"卧式加工中心"},
                }
              ]
            },
            {
              name:"龙门加工中心",
              path:"longmen",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控加工中心"},
              children:[
                {
                  name: "龙门加工中心详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控加工中心",activeSubName:"龙门加工中心"},
                }
              ]
            },
          ]
        },
        {
          name:"数控雕铣机",
          path:"engravingMillingMachine",
          component:()=>import("@/views/hoaccu"),
          meta:{activeName:"数控雕铣机"},
          redirect:"engravingMillingMachine/highSpeed",
          children:[
            {
              name:"高速雕铣机",
              path:"highSpeed",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控雕铣机"},
              children:[
                {
                  name: "高速雕铣机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控雕铣机",activeSubName:"高速雕铣机"},
                }
              ]
            },
            {
              name:"铜工雕铣机",
              path:"coppersmith",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控雕铣机"},
              children:[
                {
                  name: "铜工雕铣机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控雕铣机",activeSubName:"铜工雕铣机"},
                }
              ]
            },
            {
              name:"铝件雕铣机",
              path:"aluminium",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控雕铣机"},
              children:[
                {
                  name: "铝件雕铣机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控雕铣机",activeSubName:"铝件雕铣机"},
                }
              ]
            },
            {
              name:"石墨雕铣机",
              path:"graphite",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控雕铣机"},
              children:[
                {
                  name: "石墨雕铣机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控雕铣机",activeSubName:"石墨雕铣机"},
                }
              ]
            },
            {
              name:"刀库式雕铣机",
              path:"knife",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控雕铣机"},
              children:[
                {
                  name: "刀库式雕铣机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控雕铣机",activeSubName:"刀库式雕铣机"},
                }
              ]
            },
            {
              name:"四轴五轴雕铣机",
              path:"axis",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"数控雕铣机"},
              children:[
                {
                  name: "四轴五轴雕铣机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "数控雕铣机",activeSubName:"四轴五轴雕铣机"},
                }
              ]
            },
          ]
        },
        {
          name:"放电火花机",
          path:"SparkDischargeMachine",
          component:()=>import("@/views/hoaccu"),
          meta:{activeName:"放电火花机"},
          redirect:"SparkDischargeMachine/mirror",
          children:[
            {
              name:"镜面放电火花机",
              path:"mirror",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"放电火花机"},
              children:[
                {
                  name: "镜面放电火花机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "放电火花机",activeSubName:"镜面放电火花机"},
                }
              ]
            },
            {
              name:"ZNC放电火花机",
              path:"znc",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"放电火花机"},
              children:[
                {
                  name: "ZNC放电火花机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "放电火花机",activeSubName:"ZNC放电火花机"},
                }
              ]
            },
            {
              name:"PNC放电火花机",
              path:"pnc",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"放电火花机"},
              children:[
                {
                  name: "PNC放电火花机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "放电火花机",activeSubName:"PNC放电火花机"},
                }
              ]
            },
            {
              name:"电火花穿孔机",
              path:"small",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"放电火花机"},
              children:[
                {
                  name: "电火花穿孔机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "放电火花机",activeSubName:"电火花穿孔机"},
                }
              ]
            },
            {
              name:"中走丝线切割",
              path:"middle",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"放电火花机"},
              children:[
                {
                  name: "中走丝线切割详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "放电火花机",activeSubName:"中走丝线切割"},
                }
              ]
            },
            {
              name:"快走丝线切割",
              path:"fast",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"放电火花机"},
              children:[
                {
                  name: "快走丝线切割详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "放电火花机",activeSubName:"快走丝线切割"},
                }
              ]
            },
            {
              name:"牛头放电火花机",
              path:"cow",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"放电火花机"},
              children:[
                {
                  name: "牛头放电火花机详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "放电火花机",activeSubName:"牛头放电火花机"},
                }
              ]
            },
          ]
        },
        {
          name:"产品中心",
          path:"productCenter",
          component:()=>import("@/views/hoaccu"),
          redirect:"productCenter/millingMachine",
          meta:{activeName:"产品中心"},
          children:[
            {
              name:"铣床",
              path:"millingMachine",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"产品中心"},
              children:[
                {
                  name: "铣床详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "产品中心",activeSubName:"铣床"},
                }
              ]
            },
            {
              name:"磨床",
              path:"grindingMachine",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"产品中心"},
              children:[
                {
                  name: "磨床详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "产品中心",activeSubName:"磨床"},
                }
              ]
            },
            {
              name:"摇臂钻床",
              path:"radialDrillingMachine",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"产品中心"},
              children:[
                {
                  name: "摇臂钻床详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "产品中心",activeSubName:"摇臂钻床"},
                }
              ]
            },
            {
              name:"数控车床",
              path:"digitalControlledLathe",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"产品中心"},
              children:[
                {
                  name: "数控车床详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "产品中心",activeSubName:"数控车床"},
                }
              ]
            },

            {
              name:"代理设备",
              path:"proxyDevice",
              component:()=>import("@/views/productInfo/productList"),
              meta:{activeName:"产品中心"},
              children:[
                {
                  name: "代理设备详情",
                  path: "detail/:id",
                  component: () => import("@/views/productInfo/detail"),
                  meta: {activeName: "产品中心",activeSubName:"代理设备"},
                }
              ]
            }
          ]
        },
        {
          name:"备品备件",
          path:"sparePart",
          component:()=>import("@/views/hoaccu"),
          redirect:"sparePart/milling",
          meta:{activeName:"备品备件"},
          children:[
            {
              name:"铣床备件",
              path:"milling",
              component:()=>import("@/views/sparePart/sparePartList"),
              meta:{activeName:"备品备件"},
              children:[
                {
                  name: "铣床备件详情",
                  path: "detail/:id",
                  component: () => import("@/views/sparePart/detail"),
                  meta: {activeName: "备品备件",activeSubName:"铣床备件"},
                }
              ]
            },
            {
              name:"磨床备件",
              path:"grinder",
              component:()=>import("@/views/sparePart/sparePartList"),
              meta:{activeName:"备品备件"},
              children:[
                {
                  name: "磨床备件详情",
                  path: "detail/:id",
                  component: () => import("@/views/sparePart/detail"),
                  meta: {activeName: "备品备件",activeSubName:"磨床备件"},
                }
              ]
            },
            {
              name:"车床备件",
              path:"lathe",
              component:()=>import("@/views/sparePart/sparePartList"),
              meta:{activeName:"备品备件"},
              children:[
                {
                  name: "车床备件详情",
                  path: "detail/:id",
                  component: () => import("@/views/sparePart/detail"),
                  meta: {activeName: "备品备件",activeSubName:"车床备件"},
                }
              ]
            },
            {
              name:"火花机备件",
              path:"spark",
              component:()=>import("@/views/sparePart/sparePartList"),
              meta:{activeName:"备品备件"},
              children:[
                {
                  name: "火花机备件详情",
                  path: "detail/:id",
                  component: () => import("@/views/sparePart/detail"),
                  meta: {activeName: "备品备件",activeSubName:"火花机备件"},
                }
              ]
            },
            {
              name:"雕铣机备件",
              path:"carvesMilling",
              component:()=>import("@/views/sparePart/sparePartList"),
              meta:{activeName:"备品备件"},
              children:[
                {
                  name: "雕铣机备件详情",
                  path: "detail/:id",
                  component: () => import("@/views/sparePart/detail"),
                  meta: {activeName: "备品备件",activeSubName:"雕铣机备件"},
                }
              ]
            },
            {
              name:"加工中心备件",
              path:"macheCenter",
              component:()=>import("@/views/sparePart/sparePartList"),
              meta:{activeName:"备品备件"},
              children:[
                {
                  name: "加工中心备件详情",
                  path: "detail/:id",
                  component: () => import("@/views/sparePart/detail"),
                  meta: {activeName: "备品备件",activeSubName:"加工中心备件"},
                }
              ]
            }
          ]
        },
        {
          name:"服务与支持",
          path:"serviceSupport",
          component:()=>import("@/views/hoaccu"),
          redirect:"serviceSupport/knowledge",
          meta:{activeName:"服务与支持"},
          children:[
            {
              name:"客服知识库",
              path:"knowledge",
              component:()=>import("@/views/serviceSupport/knowledge"),
               meta:{activeName:"服务与支持"},
              children:[
                {
                  name: "客服知识库详情",
                  path: "detail/:id",
                  component: () => import("@/views/serviceSupport/detail"),
                  meta: {activeName: "服务与支持",activeSubName:"客服知识库"},
                }
              ]
            },
            {
              name:"售前与售后",
              path:"saleService",
              component:()=>import("@/views/serviceSupport/saleService"),
               meta:{activeName:"服务与支持"},
            },
            {
              name:"维修申报",
              path:"maintainService",
              component:()=>import("@/views/serviceSupport/maintainService"),
               meta:{activeName:"服务与支持"},
            },
            {
              name:"优惠活动",
              path:"specialOffer",
              component:()=>import("@/views/serviceSupport/specialOffer"),
               meta:{activeName:"服务与支持"},
            }
          ]
        },
      ]
    }
  ]
});
